import { Injectable } from '@angular/core';
import * as signalR from '@microsoft/signalr';
import { Observable, Subject } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { AuthService } from './Services/auth.service';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class SignalRService {
    private hubConnection?: signalR.HubConnection;
    private $messageReceived = new Subject<ChatMessageReceivedSignalR>();

    constructor(private authService: AuthService) {
        this.createConnection();
    }

    private getBaseUrl(url: string): string {
        // Split the URL by '/' and join the first three parts to get the base URL
        return url.split('/').slice(0, 3).join('/');
    }

    private createConnection() {
        const token = this.authService.getAccessToken();

        var baseServerUrl = environment.BASE_API_PATH;
        baseServerUrl = this.getBaseUrl(baseServerUrl);
        var signalrHubUrl = `${baseServerUrl}/artflowHub`;  //?access_token=${token}

        this.hubConnection = new signalR.HubConnectionBuilder()
            .withUrl(signalrHubUrl, {
                accessTokenFactory: () => {
                    return token || "";
                }
            })
            .withKeepAliveInterval(30000)
            .withAutomaticReconnect()
            .build();

        this.hubConnection.on('OnMessageReceived', (response: ChatMessageReceivedSignalR) => {
            this.$messageReceived.next(response);
        });
        this.hubConnection.start().catch(err => console.error('Error while starting SignalR connection: ' + err));
    }

    public attachChatMessage(): Observable<ChatMessageReceivedSignalR> {
        return this.$messageReceived.asObservable();
    }
}

export class ChatMessageReceivedSignalR {
    reciverId?: string;
    senderId?: string;
    messageId?: string;
}